import React from 'react'
import { ContentCard, OverContainerSection } from './styles'
import { MeetOurTeamLabels } from 'src/constants'
import { MapTeam } from './mapTeam'

export const CardTeam = () => {
    const { MeetOurTeamInformation } = MeetOurTeamLabels()
    return (
        <OverContainerSection id={'teams'}>
            <ContentCard
                paddingTop={['large', 'large', 'xsixty', 'xsixty']}
                marginBottom={['medium', 'medium', 'large', 'titlle']}
            >
                {MeetOurTeamInformation.map((team) => {
                    return <MapTeam key={team.id} {...team} />
                })}
            </ContentCard>
        </OverContainerSection>
    )
}
